class e {
  name;
  isSlateV1;
  isSlateV4;
  /**
   * Sets shorthand properties for the theme.
   *
   * @param name The name of the theme.
   */
  constructor(s) {
    this.name = s, this.isSlateV1 = s === "slate-v1", this.isSlateV4 = s === "slate-v4";
  }
}
export {
  e as Theme
};
//# sourceMappingURL=theme.js.map
